import { Text, Group } from '@mantine/core';
import { useMemo } from 'react';
import { getRandomTestimonial } from 'constants/testimonials';

const Testimonial = () => {
  const testimonial = useMemo(() => getRandomTestimonial(), []);
  const { name, title, image, quote } = testimonial;

  return (
    <div
      className="w-[80%] 3xl:w-[540px] mx-auto"
      style={{ minHeight: '180px' }}
    >
      <div className="bg-white rounded-xl p-6 shadow-md">
        <img src="/images/quote.svg" alt="Quotation mark icon" className="mb-2 w-3 h-3" />
        <Text size="sm" className="custom-text-color leading-[1.7]">
          <span className="opacity-80">{quote}</span>
        </Text>
        <Group align="center" gap="sm" mt="lg">
          <img
            src={image}
            alt={`${name}'s avatar`}
            className="w-10 h-10 rounded-full object-cover border border-[#5E6AB2]"
          />
          <div>
            <Text size="sm" fw={500} className="custom-text-color">
              {name}
            </Text>
            <Text size="xs" className="custom-text-color opacity-70">
              {title}
            </Text>
          </div>
        </Group>
      </div>
    </div>
  );
};

export default Testimonial;
